<template>
  <v-dialog v-model="showShareModule" persistent max-width="600px">
    <v-card>
      <v-card-title class="headline grey lighten-3">
        <span class="headline">
          <v-icon class="ml-1">fal fa-share</v-icon>
          Share to Other Users
        </span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-autocomplete
              v-model="salespersonSelect"
              :items="dealerUsers"
              item-value="id"
              item-text="name"
              :menu-props="{ closeOnClick: true }"
              label="Search users"
              multiple
              append-icon=""
              prepend-icon="fal fa-user"
            >
              <template v-slot:prepend-item v-if="dealerUsers.length > 0">
                <v-list-item ripple @click="selectAll">
                  <v-list-item-action>
                    <v-checkbox v-model="selectedAll"></v-checkbox>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title> Select All </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-divider class="mt-2"></v-divider>
              </template>

              <template v-slot:selection="{ item, index }">
                <v-chip v-if="index < 3">
                  <span>{{ item.name }}</span>
                </v-chip>

                <span v-if="index === 3" class="grey--text caption">
                  (+{{ salespersonSelect.length - 3 }} others)
                </span>
              </template>
            </v-autocomplete>
          </v-row>
        </v-container>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="shareModule" :loading="isLoading">
          Save
        </v-btn>
        <v-btn
          color="blue-grey"
          text
          @click="showShareModule = false"
          :loading="isLoading"
        >
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: 'ShareModule',

  props: {
    value: Boolean,
    module_id: Number,
  },

  data() {
    return {
      salespersonSelect: [],
      isLoading: false,
    };
  },

  computed: {
    showShareModule: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    salesPersons() {
      return this.$store.state.lmsClient.listUsers;
    },
    dealerUsers() {
      return this.salesPersons.filter(
        (salePerson) => salePerson.dealer_id === this.dealerId
      );
    },
    dealerId() {
      return this.$auth.user().dealer_id;
    },
    selectedSome() {
      return this.salespersonSelect.length > 0 && !this.selectedAll;
    },
    selectedAll() {
      return this.salespersonSelect.length === this.dealerUsers.length;
    },
  },

  methods: {
    selectAll() {
      this.$nextTick(() => {
        if (this.selectedAll) {
          this.salespersonSelect = [];
        } else {
          let allIds = this.dealerUsers.slice().map((item) => {
            return item.id;
          });
          this.salespersonSelect = allIds;
        }
      });
    },
    shareModule() {
      this.isLoading = true;
      this.$store
        .dispatch('share/shareModule', {
          user_ids: this.salespersonSelect,
          module_id: this.module_id,
        })
        .then(({ data }) => {
          this.$notify('success', 'Module Shared!', true);
          (this.salespersonSelect = []), (this.showShareModule = false);
          this.isLoading = false;
        })
        .catch(() => {
          this.$notify('error', 'Please select users!', true);
          this.isLoading = false;
        });
    },
  },
};
</script>
